import { render, staticRenderFns } from "./WheelsItineraryEditor.vue?vue&type=template&id=54d74119&scoped=true"
import script from "./WheelsItineraryEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./WheelsItineraryEditor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WheelsItineraryEditor.vue?vue&type=style&index=0&id=54d74119&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d74119",
  null
  
)

export default component.exports